<template>
  <div class="modal-overlay" v-if="isDesktop" @click="cerrar">
    <div class="modal-content" :style="{ background: fondo }" @click.stop>
      <button v-if="mostrarClose" @click="cerrar" class="close">
        <themed-icon name="close" />
      </button>
      <slot @cerrar="cerrar"></slot>
    </div>
  </div>
  <div
    v-else-if="isTablet"
    class="modal-overlay"
    :class="mobilePosition === 'bottom' ? 'bottom-align' : 'center-align'"
  >
    <div
      class="modal-content animate__animated"
      @click.stop
      :style="{
        width: center ? '50vw' : '90vw',
        minHeight: center ? '40vh' : '60vh',
        maxHeight: center ? '70vh' : '85vh',
      }"
      :class="[{ animate__fadeIn: mobilePosition === 'center' }]"
    >
      <button v-if="mostrarClose" @click="cerrar" class="close">
        <themed-icon name="close" @click="cerrar" />
      </button>
      <slot @cerrar="cerrar"></slot>
    </div>
  </div>
  <div
    v-else-if="!isDesktop && !isTablet"
    class="modal-overlay"
    :class="mobilePosition === 'bottom' ? 'bottom-align' : 'center-align'"
  >
    <template v-if="mobilePosition === 'bottom'">
      <slot @cerrar="cerrar"></slot>
    </template>

    <div
      v-else
      class="modal-content animate__animated"
      @click.stop
      :style="{
        width: center ? '77vw' : '100vw',
        minHeight: center ? '36vh' : '65vh',
        maxHeight: center ? '36vh' : '90vh',
      }"
      :class="[{ animate__fadeIn: mobilePosition === 'center' }]"
    >
      <button v-if="mostrarClose" @click="cerrar" class="close">
        <themed-icon name="close" @click="cerrar" />
      </button>
      <slot @cerrar="cerrar"></slot>
    </div>
  </div>
</template>
<script>
import ThemedIcon from "../Utils/ThemedIcon.vue";

export default {
  name: "ModalContenedorComponent",
  props: {
    cerrar: Function,
    fondo: String,
    center: Boolean,
    mostrarClose: {
      type: Boolean,
      default: true,
    },
    mobilePosition: {
      type: String,
      default: "center",
    },
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 770;
    },
    isTablet() {
      return window.innerWidth > 460 && window.innerWidth <= 770;
    },
  },
  components: {
    ThemedIcon,
  },
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100vw;
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
}
.close {
  position: absolute;
  top: 0px;
  right: 15px;
  font-size: 30px;
  z-index: 9;
  border: none;
  background: none;
  color: var(--text-primary);
}

.modal-content {
  border-radius: 1.25rem;
  max-height: var(--heightComprobantes);
  min-height: 33.389vh;
  width: auto;
  z-index: 21;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--bg-popup);
}
@media (max-width: 1360px) {
  .modal-content {
    /* background: white; */
    border-radius: 25px;
    height: auto;
    width: auto;
    z-index: 3;
  }
}
@media (max-width: 990px) {
  .modal-content {
    /* background: white; */
    border-radius: 1.5rem;
    height: auto;
    width: 50vw;
    z-index: 3;
  }
}
@media (max-width: 770px) {
  .modal-content::-webkit-scrollbar {
    display: none;
  }
  .modal-content {
    overflow-y: scroll;
    border-radius: 8px;
    max-height: var(--heightModalMobile);
    min-height: 240px;
    width: var(--widthModalMobile) !important;
    z-index: 3;
    /* background: #fff; */
    --animate-duration: 0.7s;
  }
  .close {
    position: absolute;
    top: var(--gap10);
    right: var(--gapHM10);
    font-size: unset;
    z-index: 1;
    border: none;
    background: none;
  }

  .modal-overlay.bottom-align {
    justify-content: flex-end;
    align-items: flex-end;
  }

  .modal-overlay.center-align {
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    transition: transform 0.3s ease-out;
  }

  .modal-content.animate__fadeInUpBig {
    animation: slideUp 0.35s ease-out;
  }

  .modal-overlay {
    z-index: 900;
  }

  .contenedor-general {
    z-index: 1000;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
}
</style>
